/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Rules_DescriptionInputs */



/**
* | output |
* | --- |
* | "The complete official rules for Vampire: The Eternal Struggle." |
*
* @param {Help_Rules_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const help_rules_description = /** @type {((inputs?: Help_Rules_DescriptionInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Rules_DescriptionInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les règles officielles complètes de Vampire: The Eternal Struggle.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Las reglas oficiales completas de Vampire: The Eternal Struggle.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("As regras oficiais completas de Vampire: The Eternal Struggle.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Le regole ufficiali complete di Vampire: The Eternal Struggle.")
	return /** @type {LocalizedString} */ ("The complete official rules for Vampire: The Eternal Struggle.")
});